import type { AbTestConfig } from '@/utils/abtest/abTestV3Types'

export type ABCGroups = 'A' | 'B' | 'C'
export type Issue632Groups = 'A' | 'B'

export const ISSUE_598_TOP_BANNER_AB_TEST_CONFIG: AbTestConfig<ABCGroups> = {
  state: 'stopped',
  testName: 'ISSUE_598_TOP_BANNER',
  selectedGroup: 'C'
}

export const ISSUE_616_PURCHASE_FLOW_AB_TEST_CONFIG: AbTestConfig<ABCGroups> = {
  state: 'stopped',
  testName: 'ISSUE_616_PURCHASE_FLOW',
  selectedGroup: 'B'
}

export const ISSUE_632_TOP_FV_AB_TEST_CONFIG: AbTestConfig<Issue632Groups> = {
  state: 'stopped',
  testName: 'ISSUE_632_TOP_FV',
  selectedGroup: 'B'
}

export const AB_TEST_V3_REGISTRY: AbTestConfig<string>[] = [
  ISSUE_598_TOP_BANNER_AB_TEST_CONFIG,
  ISSUE_616_PURCHASE_FLOW_AB_TEST_CONFIG,
  ISSUE_632_TOP_FV_AB_TEST_CONFIG
]
